import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'
import { unregister as unregisterServiceWorker } from './registerServiceWorker'


window.RenderApp = (config) => {
    ReactDOM.render(
        <BrowserRouter>
            <App _config={config}/>
        </BrowserRouter>, document.getElementById('root'));
    //registerServiceWorker();
    unregisterServiceWorker();
}


// WEBPACK FOOTER //
// ./src/index.js